const concat = "<br />"
const aboutneo = {
    "About NeoGrowth": [
        {
          question: "What is the business of NeoGrowth Credit Private Limited (NeoGrowth)?",
          answer: "NeoGrowth Credit Pvt. Ltd is a Systemically Important, Non-Deposit taking RBI Registered NBFC and a pioneer in SME lending based on the underwriting of digital payments data. They commenced operations in 2013. Their loans are powered by technology innovations and leverage the digital payments ecosystem. The company is founded by Mr. Dhruv Khaitan and Mr. Piyush Khaitan who have a shareholding of 20.7%." +
          "<br /><br />" +
          "The company was founded by Mr. Dhruv Khaitan and Mr.  Piyush Khaitan, and its investors include Omidyar Network, Aspada Investment Advisors, Khosla Impact Fund, Frontier Investments Group (Accion), West Bridge Crossover Fund, Trinity Inclusion Ltd. (Leapfrog), Mr. Arun Nayyar {Managing Director (MD) & Chief Executive Officer (CEO)), IIFL Seed Ventures Fund and FMO (the Dutch entrepreneurial development bank)."
        },
        {
          question: "What are the strengths of NeoGrowth?",
          answer: "- Long Track record of the company in the SME Digital Lending space" + concat +
          "- Granular & Diversified Portfolio - ~70% portfolio with average ticket size < ₹30 Lakhs." + concat +
          "- Strong Investors - Omidyar Network, Aspada Investment Advisors, Khosla Impact Fund, Frontier Investments Group (Accion), West Bridge Crossover Fund, IIFL Seed Ventures Fund and FMO (the Dutch entrepreneurial development bank)." + concat +
          "- Improved asset quality with low NPAs - GNPA: 3.5% and NNPA : 1.7%" + concat +
          "- Healthy Capitalization – Capital Adequacy ratio is 30.4% which is significantly higher than RBI minimum limit of 15%" + concat +
          "- Diversified Borrowing – International Borrowing includes from Developmental Financial Institutions (DFIs) which is 61% of borrowing book. Domestic lenders include banks like Indian Bank, RBL bank, Federal Bank, SIDBI." + concat +
          "- Strong Yield of 26.2% and NIM of 13%" + concat
        },
        {
          question: "What are the major risks to NeoGrowth?",
          answer: "- Moderate Borrower profile – Unsecured Nature of Loans and moderate borrowing profile of borrowers" + concat +
          "- Weak but improving Profitability – The company reported a Profit After Tax (PAT) of ₹ 10+ Crs in Q1FY24." + concat 
        },
        {
          question: "What is the Credit rating for NeoGrowth?",
          answer: "NeoGrowth is rated BBB/ Stable by ICRA and CARE"
        },
        {
          question: "What is the AUM of NeoGrowth?",
          answer: "The Consolidated AUM as on 30th Jun 2023 is ₹ 2,088 Crs."
        },
        {
          question: "What is the profitability of NeoGrowth?",
          answer: "The Yield of the portfolio is 26.5% <br />" + 
            "Net Interest Margin is 16% <br />" + 
            "Opex/ NIM is 47% <br />" + 
            "Profit Before Tax (PBT) is ₹ 16 Crs<br />" +
            "Profit After Tax (PAT) is ₹ 12 Crs<br />" +
            "Return of Asset (ROA) is 2.6%<br />" +
            "Return on Equity (ROE) is 8.6%<br />" +
            "(Data for Q1FY24)" 
        },
        {
          question: "How is the asset quality of NeoGrowth?",
          answer: "The GNPA has improved from 9.9% in Q1FY23 to 3.5% in Q1FY24 and NNPA from 4.1% to 1.7%."
        },
        {
          question: "What is the Capital Adequacy ratio?",
          answer: "The consolidated Capital Adequacy Ratio (CRAR) as on Jun 2023 is 30.4%"
        },
      ],
  }
  
  export default aboutneo;